import React, { useEffect, useRef, useCallback, useState } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    languageMenuAction,
    authMenuAction,
    profileMenuAction
} from '../../actions/settingsAction';
import { clearAuthData } from '../../pages/Authentication/store/authSlice';
import { useTranslation } from 'react-i18next';
import { LANGUAGE } from '@/utils/constants';
import { studentsApi, teachersApi, usersApi } from '@/api';
import { notification } from 'antd';

const HeaderComponent = ({ ...props }) => {
    const { user } = useSelector((state) => state.profile);
    const authData = useSelector((state) => state.auth);
    const profileMenu = useSelector((state) => state.settings.isProfileMenu);
    const fixNavbar = useSelector((state) => state.settings.isFixNavbar);
    const darkHeader = useSelector((state) => state.settings.isDarkHeader);
    const { i18n, t } = useTranslation(); // Thêm 't'
    const [showLangChange, setShowLangChange] = useState(false);

    const dispatch = useDispatch();

    const authMenuActionFn = useCallback((e) => dispatch(authMenuAction(e)), [dispatch]);
    const languageMenuActionFn = useCallback((e) => dispatch(languageMenuAction(e)), [dispatch]);
    const profileMenuActionFn = useCallback((e) => dispatch(profileMenuAction(e)), [dispatch]);

    const leftSidebarRef = useRef(null);

    const hideLeftSidebarProxy = useCallback(
        (e) => {
            if (leftSidebarRef.current && leftSidebarRef.current.contains(e.target)) {
                authMenuActionFn(false);
                languageMenuActionFn(false);
                return;
            }
        },
        [
            authMenuActionFn,
            languageMenuActionFn,
        ]
    );

    useEffect(() => {
        document.addEventListener('mousedown', hideLeftSidebarProxy, false);
        return () => {
            document.removeEventListener('mousedown', hideLeftSidebarProxy, false);
        };
    }, [hideLeftSidebarProxy]);

    const handleChangeLanguage = async (lang) => {
        i18n.changeLanguage(lang);
        
        if (!(authData?.roles[0].name === 'Admin')) {
            const apiToUse =
                authData?.roles[0].name === 'Student'
                    ? studentsApi
                    : authData?.roles[0].name === 'Teacher'
                    ? teachersApi
                    : null;

            if (!apiToUse) {
                console.error('Cannot determine user role for API call');
                notification.error({ message: t('Profile_Notify_UpdateFailedInvalidRole') });
                return;
            }

            try {
                const payload = {
                    language: lang,
                    id: user?.id
                };

                await apiToUse.update(payload);
            } catch (err) {
                console.error('Error update language');
            }
        }
    };

    return (
        <div
            ref={leftSidebarRef}
            className={`section-body ${fixNavbar ? 'sticky-top' : ''} ${
                darkHeader ? 'top_dark' : ''
            }`}
            id="page_top">
            <div className="container-fluid">
                <div className="page-header">
                    <div className="left"></div>
                    <div className="right">
                        <div className="notification d-flex">
                            <div className={`dropdown d-flex${showLangChange ? ' show' : ''}`}>
                                <span
                                    className="nav-link icon d-none d-md-flex btn btn-default btn-icon ml-1"
                                    onClick={() => setShowLangChange(!showLangChange)}>
                                    <i className="fa fa-language"></i>
                                </span>
                                <div
                                    className={`dropdown-menu dropdown-menu-right dropdown-menu-arrow${
                                        showLangChange ? ' show dLang' : ''
                                    }`}>
                                    {LANGUAGE.map((ele, idx) => {
                                        return (
                                            <span
                                                key={idx}
                                                className="dropdown-item flex cursor-pointer"
                                                onClick={() => {
                                                    setShowLangChange(!showLangChange);
                                                    handleChangeLanguage(ele.key);
                                                }}>
                                                <img
                                                    className="w20 mr-2"
                                                    src={ele?.icon}
                                                    alt={t('Header_LanguageFlag')}
                                                />
                                                {t(ele?.label)}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className={`dropdown d-flex${profileMenu ? ' show' : ''}`}>
                                <span
                                    className="chip ml-3"
                                    onClick={() => profileMenuActionFn(!profileMenu)}>
                                    {user?.avatar && authData?.roles[0].name !== 'Admin' ? (
                                        <img
                                            src={user?.avatar}
                                            className="avatar"
                                            alt="User Avatar" // Thêm alt
                                        />
                                    ) : (
                                        <span
                                            className="avatar"
                                            style={{
                                                backgroundImage: `url(../assets/images/user.jpg)`
                                            }}></span>
                                    )}
                                    {user?.firstName} {user?.lastName}
                                </span>
                                <div
                                    className={`dropdown-menu dropdown-menu-right dropdown-menu-arrow${
                                        profileMenu ? ' show dProfile' : ''
                                    }`}>
                                    {(authData?.roles[0]?.name === 'Teacher' ||
                                        authData?.roles[0]?.name === 'Student') && (
                                        <>
                                            <Link
                                                onClick={() => profileMenuActionFn(!profileMenu)}
                                                className="dropdown-item"
                                                to="/pageProfile">
                                                <i className="dropdown-icon fe fe-user"></i>{' '}
                                                {t('Header_Profile')}
                                            </Link>
                                            <div className="dropdown-divider"></div>
                                        </>
                                    )}
                                    <Link
                                        className="dropdown-item"
                                        to="/login"
                                        onClick={() => {
                                            profileMenuActionFn(!profileMenu);
                                            dispatch(clearAuthData());
                                        }}>
                                        <i className="dropdown-icon fe fe-log-out"></i>{' '}
                                        {t('Header_SignOut')}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

HeaderComponent.displayName = 'Header';

const Header = (props) => {
    return (
        <ErrorWrapper>
            <HeaderComponent
                data-id="Header-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default Header;
